import React from 'react'
import './Footer.scss';
import { NavLink } from 'react-router-dom';
export default function Footer() {
  return (
    <div>
      <footer className='main_footer footerDarkBg'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-4'>
              <div className='footer_title'>
                <h2>Working TIme</h2>
                <ul>
                <li><span>Monday</span> 10:00 AM – 9:30 PM</li>
                <li><span>Tuesday</span> 10:00 AM – 9:30 PM</li>
                <li><span>Wednesday</span> 10:00 AM – 9:30 PM</li>
                <li><span>Thursday</span> 10:00 AM – 9:30 PM</li>
                <li><span>Friday</span> 10:00 AM – 9:30 PM</li>
                <li><span>Saturday</span> 10:00 AM – 9:30 PM</li>
                <li><span>Sunday</span> 10:00 AM – 9:30 PM</li>
                </ul>
              </div>
            </div>
            <div className='col-md-4'>
              <div className='footer_title'>
                <h2>Address</h2>
                <p>Shop no 18, 19 GF, Silver Plaza, Silver Chowk, Punagam Near Devi Darshan Society surat, Gujarat 395010 India</p>
                <p className='m-0'><a href="tel:9909909311">9909909311</a></p>
                <p><a href="mailto:otlocafe@gmail.com">otlocafe@gmail.com</a></p>
              </div>
            </div>
            <div className='col-md-4'>
              <div className='footer_title'>
                <h2>Contact Us</h2>
                <div className='socialBtn'>
                  <ul>
                    <li><a href="#"><i class="fa-brands fa-facebook-f"></i></a></li>
                    <li><a href="#"><i class="fa-brands fa-twitter"></i></a></li>
                    <li><a href="#"><i class="fa-brands fa-behance"></i></a></li>
                    <li><a href="#"><i class="fa-brands fa-instagram"></i></a></li>
                  </ul>
                </div>
                <div className='linerBtn'>
                  <NavLink to="/contactus">Contact Us</NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className='copyRight_wrap textCenter'>
        <div className='container'>
            <div className='copy-rigt-alignment'>
              <p>Copyright by 2022 Otlo the cafe</p>
              <p>Powered by <a href='https://rejoicehub.com/' target="_blank">Rejoicehub Solutions</a></p>
            </div>
        </div>
      </div>
    </div>
  )
}
